import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { TranslateFunction } from 'react-localize-redux';

import { Button, Divider, Typography } from '../../../../components/atoms';
import { LoyaltyProgressBar } from '../../../../components/molecules/LoyaltyProgressBar';
import { LoyaltyRequiredCondition } from '../../../../core/state/store/store.types';

export type Props = {
  requirements: LoyaltyRequiredCondition;
  showPending?: boolean;
  translate: TranslateFunction;
};

const useStyles = makeStyles((theme: Theme) => ({
  actionText: {
    fontSize: `${theme.typography.pxToRem(13)} !important`,
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  description: {
    fontSize: theme.typography.pxToRem(13),
    lineHeight: '18px',
    marginBottom: theme.spacing(0.25),
  },
  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  loyaltyProgressBar: {
    width: '100%',
  },
  root: {
    border: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: 12,
  },
  starProgress: {
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    boxSizing: 'border-box',
    display: 'flex',
    height: 60,
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    minWidth: 60,
    paddingTop: theme.spacing(1.5),
  },
  starNumberLeft: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.pxToRem(28),
    marginBottom: theme.spacing(1.5),
  },
  starNumberRight: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.pxToRem(13),
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

export function LoyaltyCard(props: Props): JSX.Element {
  const classes = useStyles();
  const { requirements, showPending = false, translate } = props;
  const rootStyles = clsx('fd-loyalty-card', classes.root);
  const {
    CurrentValue: currentValue,
    Description: description,
    RequiredValue: requiredValue,
  } = requirements;

  return (
    <div className={rootStyles}>
      <Typography className={classes.title}>
        {translate('LoyaltyCard_YourLoyaltyProgress')}
      </Typography>
      <div className={classes.loyaltyProgressBar}>
        <LoyaltyProgressBar
          currentStar={parseInt(currentValue)}
          showPendingStar={showPending}
          totalStars={parseInt(requiredValue)}
        />
      </div>

      <div className={classes.divider}>
        <Divider />
      </div>
      <div className={classes.bottomSection}>
        <div className={classes.starProgress}>
          <Typography className={classes.starNumberLeft}>
            {currentValue}
          </Typography>
          <Typography className={classes.starNumberRight}>
            /{requiredValue}
          </Typography>
        </div>
        <div>
          <Typography className={classes.description} variant="caption">
            {description}
          </Typography>
          <Button onClick={() => {}} variant="text">
            <Typography className={classes.actionText}>
              {translate('LoyaltyCard_HowLoyaltyWorks')}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
}
